import React from 'react';
import PropTypes from 'prop-types';

function listCell({ cell: { value } }) {
  return <div>{value ? value.map((team) => team.name).join(', ') : ''}</div>;
}

listCell.propTypes = {
  cell: PropTypes.object,
};

export default listCell;
